/**
 * @description SO source-connector session API (LYN-267 / LYN-375)
 *
 * @dependencies apiClient
 * @notes Secret is write-only. Connect never returns a password.
 *   Assign picks an existing secret and does not copy the password.
 *   Current company is X-Company-Id from apiClient.
 *   test-pull may send from/to for historical. Connect does not.
 *   Continue sends { continue: true } and no from/to.
 *   Retry sends { retry: true } for that failed window only.
 *   Catch-up sends { utilizationCatchUp: true }. Server reads the Analysis span.
 *   Assign uses the same 90s timeout as connect. Paused assign verifies login.
 */

import apiClient from './apiClient';

export const listSoConnectors = () =>
  apiClient.get('/so/source-connectors').then((r) => r.data);

export const connectSoConnector = (connectorId, body) =>
  apiClient.post(`/so/source-connectors/${connectorId}/connect`, body, {
    timeout: 90000
  }).then((r) => r.data);

export const assignSoConnector = (connectorId, connectionId, credentials) =>
  apiClient.post(`/so/source-connectors/${connectorId}/assign`, {
    connectionId,
    ...(credentials || {})
  }, {
    timeout: 90000
  }).then((r) => r.data);

export const unassignSoConnector = (connectorId) =>
  apiClient.post(`/so/source-connectors/${connectorId}/unassign`).then((r) => r.data);

export const disconnectSoConnector = (connectorId) =>
  apiClient.post(`/so/source-connectors/${connectorId}/disconnect`).then((r) => r.data);

export const resumeSoConnector = (connectorId) =>
  apiClient.post(`/so/source-connectors/${connectorId}/resume`).then((r) => r.data);

export const testPullSoConnector = (connectorId, body = {}) =>
  apiClient.post(`/so/source-connectors/${connectorId}/test-pull`, body, {
    timeout: 180000
  }).then((r) => r.data);
